import { Link, Text, Button as VuiButton } from '@village/ui';
import { Banner } from 'components/banner';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { device } from 'utils/device';

const Container = styled.div`
    padding: 1rem;

    @media ${device.minLaptopM} {
        margin: 0 auto;
        max-width: 1344px;
    }
`;

const Header = styled.div`
    position: relative;
    display: grid;
    gap: 1rem;
    z-index: 3;
`;

const Footer = styled.div`
    border-radius: 8px;
    box-shadow: 0 2px 6px rgb(23 51 91 / 10%);
`;

const FormContainer = styled.div`
    display: grid;
    gap: 1rem;
    padding: ${rem(16)} 0;

    @media ${device.minTablet} {
        grid-template-columns: auto auto ${rem(114)};
    }
`;

const NavigationContainer = styled.div`
    position: sticky;
    top: ${rem(72)};
    z-index: 2;
    display: grid;
    padding: ${rem(16)} 0;
    background-color: #fff;
    border-bottom: 2px solid #eaebec;
    border-top: 2px solid #eaebec;

    @media ${device.minLaptopM} {
        grid-template-columns: 1fr 1fr;
    }

    @media ${device.maxTablet} {
        top: ${rem(70)};
        border-bottom: 1px solid #eaebec;
        border-top: 1px solid #eaebec;
    }
`;

const NavigationBannerContainer = styled.div`
    display: none;

    @media ${device.minLaptopM} {
        display: block;
    }
`;

const AppointmentsContainer = styled.div<{ $loading: boolean }>`
    ${({ $loading }) =>
        $loading &&
        css`
            background-color: rgba(256, 256, 256, 0.7);
            pointer-events: none;
        `};
`;

const DepartmentTimezone = styled.p`
    color: #666;
    margin: 0.5rem 0;
`;

const RelativeContainer = styled.div`
    position: relative;
`;

const SpinnerContainer = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(256, 256, 256, 0.7);
    pointer-events: none;
    z-index: 1;
`;

const SpinnerWrapper = styled.div`
    position: sticky;
    top: 10rem;
`;

const MissingReasonTitle = styled(Text)`
    font-weight: bold;
    text-align: center;
    margin: 2rem 0;
`;

const ContactBannerContainer = styled(Banner)`
    margin-top: ${rem(32)};
    color: ${({ theme }) => `${theme.vui.colors.text.default} !important`};
    & svg {
        margin-right: ${rem(12)};
    }

    @media ${device.maxTablet} {
        align-items: normal;
        margin-top: ${rem(24)};
    }
`;

const ContactText = styled.span`
    display: block;
    flex-direction: row;
    color: ${({ theme }) => `${theme.vui.colors.surface.secondary} !important`};
    background-color: ${({ theme }) => theme.vui.colors.background.gray};
`;

const ContactTextLink = styled(Link)`
    text-decoration: underline;
    margin-left: ${rem(8)};

    @media ${device.maxTablet} {
        display: block;
        margin-left: 0;
    }
`;

const ButtonWrapper = styled.div`
    display: block;
    text-align: right;

    @media ${device.maxTablet} {
        text-align: left;
    }
`;

const Button = styled(VuiButton)`
    margin: 0 auto;
    background-color: transparent;
`;

const SwitchToVideoBannerContainer = styled(Banner)`
    margin-top: ${rem(32)};
    color: ${({ theme }) => `${theme.vui.colors.text.default} !important`};

    @media ${device.maxTablet} {
        background: #dceaef;
    }
`;

const SwitchToVideoGrid = styled.div`
    display: grid;
    grid-template-columns: 3fr 1fr;
    align-items: center;

    @media ${device.maxTablet} {
        grid-template-columns: 1fr;
    }
`;

const SwitchToVideoBannerHeader = styled(ContactText)`
    background: none;
    font-weight: 400;
    margin-bottom: ${rem(4)};
    font-size: ${rem(20)};
    line-height: ${rem(28)};

    @media ${device.maxTablet} {
        font-weight: 700;
        font-size: ${rem(16)};
        line-height: ${rem(24)};
        margin-bottom: ${rem(8)};
    }
`;

const SwitchToVideoBannerText = styled(ContactText)`
    background: none;
    font-size: ${rem(18)};
    line-height: ${rem(28)};
    color: ${({ theme }) => `${theme.vui.colors.text.secondary} !important`};

    @media ${device.maxTablet} {
        font-size: ${rem(16)};
        line-height: ${rem(24)};
        margin-bottom: ${rem(8)};
    }
`;

const SwitchToVideoBannerAddonText = styled.span`
    @media ${device.maxTablet} {
        display: none;
    }
`;

export {
    Banner,
    Container,
    ContactBannerContainer,
    ContactText,
    ContactTextLink,
    Header,
    Footer,
    FormContainer,
    SpinnerContainer,
    SpinnerWrapper,
    RelativeContainer,
    NavigationContainer,
    AppointmentsContainer,
    NavigationBannerContainer,
    DepartmentTimezone,
    MissingReasonTitle,
    ButtonWrapper,
    Button,
    SwitchToVideoBannerContainer,
    SwitchToVideoBannerHeader,
    SwitchToVideoBannerText,
    SwitchToVideoGrid,
    SwitchToVideoBannerAddonText,
};
